export interface StockItemProductEnquiry {
  id: string;
  stockNo: string;
  dateCreated: Date;
  createdBy: string;
  balance: number;
  pricePerUnit: number;
  warehouse: string;
  location: string;
  grade: string;
  gradeDescription: string;
  makeUp: string;
  batchNo: string;
  allocated: number;
  available: number;
  seconds: number;
  commentsExist: boolean;
  colour: string;
}
